import textInputModel from "../../../../models/general/elements/inputElements/textInput.model";
import TextAreaInputElementComponent from "../../../general/elements/inputElements/TextAreaInputElementComponent";
import TextInputElementComponent from "../../../general/elements/inputElements/TextInputElementComponent";

export const WebsiteConfigurationAboutSection = ({ props }) => {
  const { currentValue, handleChange } = props;

  const getHomeAboutTitleInputsElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "Title",
      value: currentValue.Title,
      onChange: handleChange,
      label: "כותרת",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getHomeAboutTextInputsElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "Text",
      value: currentValue.Text,
      onChange: handleChange,
      label: "תוכן",
    };
    return <TextAreaInputElementComponent props={inputProps} />;
  };
  return (
    <>
      {getHomeAboutTitleInputsElement()}
      {getHomeAboutTextInputsElement()}
    </>
  );
};

export default WebsiteConfigurationAboutSection;
